export default __webpack_public_path__ + "static/media/google.20252b0c.svg";